import { render, staticRenderFns } from "./GJMIndex.vue?vue&type=template&id=52e56f9a&"
import script from "./GJMIndex.vue?vue&type=script&lang=js&"
export * from "./GJMIndex.vue?vue&type=script&lang=js&"
import style0 from "./GJMIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports